// extracted by mini-css-extract-plugin
export default {"table-body":"SingleProfile_table-body__EB8fh","row1":"SingleProfile_row1__0ecku","Feedback":"SingleProfile_Feedback__ylbAk"};